import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-benefit-item__title" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--b2 _tc--gray" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-benefit-item', $options.benefitClass])
  }, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString($props.title), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.description), 1 /* TEXT */)
  ], 2 /* CLASS */))
}